import { BaseResponse } from './base.response';

export class MinimumRequiredDateResponse extends BaseResponse {

  public requiredDate: Date;

}
